import { render, staticRenderFns } from "./TestedVersionDialog.vue?vue&type=template&id=c823c5e4&"
import script from "./TestedVersionDialog.vue?vue&type=script&lang=js&"
export * from "./TestedVersionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports